import { Document, Image, Page, View } from '@react-pdf/renderer';
import React from 'react';
import logo from './AssistPoint_Logo.png';
import PdfTab from './PdfTab';
import SpectrumServiceBrand from './SpectrumServiceBrand';

const styles = {
    page: { paddingTop: 35, paddingBottom: 35, paddingHorizontal: 35 }
}

const SpectrumPdf = props => {
    const { form, tabs } = props;

    return <Document>
        <Page size="A4" style={styles.page}>
            <View>
                <View>
                    <Image src={logo} size='small' style={{ width: 200 }} />
                </View>

                <SpectrumServiceBrand services={form.meta.assistanceServices} brand={form.meta.brandName} />

                {tabs.map(tab =>
                    <PdfTab
                        key={tab.key}
                        name={tab.name}
                        sections={tab.sections}
                        form={form}
                    />
                )}
            </View>
        </Page>
    </Document>
}

export default SpectrumPdf;
